module.exports = __webpack_public_path__ + "static/media/bash.6384cd5d.svg";